/** biome-ignore-all lint: <third-party script, do not lint> */
import { useEffect } from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { CustomerServiceLink } from 'autogen/translation-keys/trans-website-shared';

type AvailableLanguages = 'nb-NO' | 'sv-SE' | 'fi-FI';

// Script from kicks
const humanyScript = () => {
    (function (a, b, c, d, e, f, g) {
        for (var h, i = /[?&]{1}(humany[^=]*)=([^&#]*)/g; (h = i.exec(a.location.search)); )
            c += (-1 < c.indexOf('?') ? '&' : '?') + h[1] + '=' + h[2];
        (f = b.createElement(e)),
            (f.async = !0),
            (f.src = c),
            (g = b.getElementsByTagName(e)[0]),
            g.parentNode.insertBefore(f, g),
            (a[d] = a[d] || {
                _c: [],
                configure: function () {
                    a[d]._c.push(arguments);
                }
            });
        var j = d.toLowerCase();
        a[j] = a[j] || {
            _c: [],
            configure: function () {
                a[j]._c.push(arguments);
            }
        };
    })(window, document, '//kicks.humany.net/one-widget-implementation/embed.js', 'Humany', 'script');
};

function Humany(props: { locale?: string }) {
    const { locale } = props;
    const { t } = useTranslation();

    if (!locale) return null;

    const translation = t(CustomerServiceLink);

    const elementsMap: Record<AvailableLanguages, JSX.Element> = {
        'sv-SE': <a href="//kicks.humany.net/one-widget-inline">{translation}</a>,
        'nb-NO': <a href="//kicks.humany.net/one-widget-inline-no">{translation}</a>,
        'fi-FI': <a href="//kicks.humany.net/one-widget-inline-fi">{translation}</a>
    };

    const element = elementsMap[locale] || null;

    if (!element) return null;

    useEffect(() => {
        humanyScript();
    }, []);

    return element;
}

export default withErrorBoundary(Humany, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
